import { makeStyles } from "@material-ui/core/styles";

import { P } from "./constants";

export const useOverviewStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    paddingBottom: 8,
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4,minmax(0,1fr))",
    gap: 12,
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  tile: {
    background: "var(--color-background-primary)",
    border: "1px solid var(--color-border-tertiary)",
    borderRadius: 10,
    padding: "14px 16px",
  },
  leadTile: { borderColor: "var(--color-border-secondary)" },
  label: { color: "var(--color-text-secondary)", fontWeight: 500 },
  value: {
    color: P.headline,
    fontWeight: 600,
    letterSpacing: "-.02em",
    marginTop: 4,
  },
  delta: { display: "flex", alignItems: "center", gap: 4, marginTop: 6 },
  metricPace: { marginTop: 8 },
  muted: { color: "var(--color-text-secondary)" },
  faint: { color: "var(--color-text-tertiary)" },
  badge: {
    display: "inline-flex",
    padding: "2px 7px",
    marginLeft: 6,
    borderRadius: 4,
    fontSize: 11,
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    background: "var(--color-background-secondary)",
  },
  disclosure: {
    background: "var(--color-background-primary)",
    border: "1px solid var(--color-border-tertiary)",
    borderRadius: 8,
    padding: "9px 12px",
    marginTop: 10,
  },
  disclosureSummary: {
    cursor: "pointer",
    color: "var(--color-text-secondary)",
    fontSize: 13,
    fontWeight: 600,
  },
  aboutGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0,1fr) minmax(280px,.7fr)",
    gap: 24,
    marginTop: 14,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  definition: { marginBottom: 10 },
  term: { color: "var(--color-text-primary)", fontWeight: 600 },
  definitionText: {
    color: "var(--color-text-secondary)",
    marginTop: 2,
    lineHeight: 1.45,
  },
  budgetInputs: {
    background: "var(--color-background-secondary)",
    border: "1px solid var(--color-border-tertiary)",
    borderRadius: 8,
    padding: 12,
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginTop: 9,
  },
  inputControl: { display: "flex", alignItems: "center", gap: 6 },
  numInput: { width: 90 },
  smallButton: { textTransform: "none", minWidth: 50, padding: "4px 8px" },
  sectionHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 10,
  },
  heading: { color: "var(--color-text-primary)", fontWeight: 600 },
  aside: { color: "var(--color-text-secondary)" },
  surface: {
    background: "var(--color-background-primary)",
    border: "1px solid var(--color-border-tertiary)",
    borderRadius: 10,
    padding: 18,
  },
  actionList: { padding: 0, overflow: "hidden" },
  actionRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: 24,
    alignItems: "center",
    padding: "14px 18px",
    borderTop: "1px solid var(--color-border-tertiary)",
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  actionRowFirst: { borderTop: 0 },
  actionTag: { color: "var(--color-text-secondary)", marginBottom: 2 },
  actionTitle: {
    color: "var(--color-text-primary)",
    fontWeight: 600,
    lineHeight: 1.35,
  },
  actionDetail: {
    color: "var(--color-text-secondary)",
    marginTop: 4,
    lineHeight: 1.45,
  },
  primaryButton: {
    textTransform: "none",
    color: "#fff",
    background: P.nv,
    width: 152,
    whiteSpace: "nowrap",
    "&:hover": { background: P.pd },
  },
  revenueSummary: {
    display: "grid",
    gridTemplateColumns: "repeat(4,minmax(0,1fr))",
    gap: 12,
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    },
  },
  revenueOverview: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 24,
    marginBottom: 14,
    [theme.breakpoints.down("sm")]: { flexDirection: "column" },
  },
  revenueActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    minWidth: 120,
    [theme.breakpoints.down("sm")]: { alignItems: "flex-start", minWidth: 0 },
  },
  revenueTransactions: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottom: "1px solid var(--color-border-tertiary)",
  },
  summaryItem: {
    paddingRight: 12,
    borderRight: "1px solid var(--color-border-tertiary)",
  },
  summaryValue: { color: P.headline, fontWeight: 600, marginTop: 2 },
  progressRoot: {
    height: 5,
    borderRadius: 3,
    backgroundColor: "var(--color-background-secondary)",
  },
  progressBar: { borderRadius: 3, backgroundColor: P.am },
  progressBarBehind: { borderRadius: 3, backgroundColor: "#FF3B30" },
  legendRow: { display: "flex", flexWrap: "wrap", gap: 14, marginBottom: 8 },
  legend: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    color: "var(--color-text-secondary)",
  },
  swatch: { width: 18, height: 3, borderRadius: 1, display: "inline-block" },
  chart: { height: 220 },
  leakList: { display: "flex", flexDirection: "column", gap: 11, marginTop: 4 },
  leakRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    gap: 12,
    marginBottom: 4,
  },
  segmentTableWrap: { overflowX: "auto" },
  segmentTable: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  tableHead: {
    color: "var(--color-text-secondary)",
    fontWeight: 500,
    padding: "7px 8px",
    borderBottom: "1px solid var(--color-border-tertiary)",
    whiteSpace: "nowrap",
  },
  tableCell: {
    padding: "9px 8px",
    borderBottom: "1px solid var(--color-border-tertiary)",
  },
  segmentDot: {
    width: 7,
    height: 7,
    borderRadius: 2,
    display: "inline-block",
    marginRight: 7,
  },
  occupancyStats: { display: "flex", flexWrap: "wrap", gap: 32, marginBottom: 14 },
  occupancyLabel: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minHeight: 25,
  },
  occupancyChart: { height: 200 },
  topMargin8: { marginTop: 8 },
  topMargin10: { marginTop: 10 },
  topMargin12: { marginTop: 12 },
  textRight: { textAlign: "right" },
}));
